import React, { useEffect, useRef } from "react";
import { QRCodeCanvas } from "qrcode.react"; // ✅ Correction de l'import

const QRCodeGenerator = ( { data, setQrImage } ) =>
{
    const qrRef = useRef( null );

    useEffect( () =>
    {
        if ( data && qrRef.current )
        {
            const canvas = qrRef.current.querySelector( "canvas" );
            if ( canvas )
            {
                const qrImage = canvas.toDataURL( "image/png" ); // Convertir en base64
                setQrImage( qrImage ); // Mettre à jour l'état dans le parent
            }
        }
    }, [ data ] );

    return (
        <div ref={ qrRef } style={ { display: "none" } }>
            <QRCodeCanvas value={ JSON.stringify( data ) } /> {/* ✅ Correction ici */ }
        </div>
    );
};

const AfficherQR = ( { qrImage, ...props } ) =>
{
    return (
        <div
            // style={ { } }
            { ...props }
            // style={ { borderWidth: 2, borderColor: "red" } }
            className="align-content-center justify-items-center border"
        >
            { qrImage ? (
                <img
                    src={ qrImage }
                    alt="QR Code"
                    style={ {
                        borderWidth: 2,
                        width: "100%",
                        height: "100%"
                    } }
                />
            ) : (
                <p>QR indisponible</p>
            ) }
        </div>
    );
};

export { QRCodeGenerator, AfficherQR };
